import React, { useState } from 'react';
import {
    RiFacebookLine as Facebook,
    RiInstagramLine as Instagram,
    RiTiktokFill as Tiktok,
    RiWhatsappLine as Whatsapp,
    RiMapPinLine as MapPin,
    RiMailLine as Mail,
    RiPhoneLine as Phone,
} from '@remixicon/react';
import SocialIcons from '../common/SocialIcons';
import HexagonCornerDecoration from '../common/HexagonCornerDecoration';
import { useTheme } from '../../context/ThemeContext.tsx';

const colors = {
    primary: '#c1348b',
    primaryDark: '#8f1f64',
    secondary: '#61257b',
    secondaryLight: '#8b3fa8',
    accent: '#ffd97c',
    accentDark: '#ea8406',
    moradoPrincipal: '#61257B',
    moradoVariante: '#C1348B',
};

const Footer = () => {
    const { isDark } = useTheme();
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);

    const handleSubscribe = () => {
        if (email.trim()) { setSent(true); setTimeout(() => setSent(false), 3000); setEmail(''); }
    };

    const socialLinks = [
        { Icon: Facebook, url: 'https://www.facebook.com/CoMarcaCoworkconProposito/', label: 'Facebook', color: '#1877F2' },
        { Icon: Instagram, url: 'https://www.instagram.com/comarcacowork/', label: 'Instagram', color: '#E1306C' },
        { Icon: Tiktok, url: 'https://www.tiktok.com/@co_marca_cowork', label: 'TikTok', color: '#010101' },
        { Icon: Whatsapp, url: 'https://api.whatsapp.com/send?phone=59176204601&text=Hola%20desde%20la%20web', label: 'WhatsApp', color: '#25D366' },
    ];

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700;800;900&display=swap');

        .footer-link {
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          font-size: 0.9rem;
          font-weight: 400;
          transition: color 0.2s;
          display: block;
          padding: 3px 0;
        }
        .footer-link:hover { color: #FFD97C; }

        .social-btn {
          width: 40px; height: 40px;
          border-radius: 50%;
          background: rgba(255,255,255,0.08);
          border: 1.5px solid rgba(255,255,255,0.15);
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all 0.22s;
          text-decoration: none;
        }
        .social-btn:hover {
          background: #C1348B;
          border-color: #FFD97C;
          transform: translateY(-3px);
        }

        .subscribe-input {
          flex: 1;
          background: rgba(255,255,255,0.08);
          border: 1.5px solid rgba(255,255,255,0.18);
          border-right: none;
          border-radius: 12px 0 0 12px;
          padding: 11px 16px;
          color: #fff;
          font-size: 0.9rem;
          font-family: 'DM Sans', sans-serif;
          outline: none;
          transition: border-color 0.2s;
        }
        .subscribe-input::placeholder { color: rgba(255,255,255,0.45); }
        .subscribe-input:focus { border-color: #C1348B; }

        .subscribe-btn {
          background: linear-gradient(135deg, #61257B, #C1348B);
          border: none;
          border-radius: 0 12px 12px 0;
          padding: 11px 20px;
          color: #fff;
          font-size: 0.88rem;
          font-weight: 700;
          font-family: 'DM Sans', sans-serif;
          cursor: pointer;
          transition: all 0.2s;
          white-space: nowrap;
          box-shadow: 0 4px 14px rgba(97,37,123,0.4);
        }
        .subscribe-btn:hover { filter: brightness(1.15); transform: translateY(-1px); }

        .contact-item {
          display: flex; align-items: flex-start; gap: 12px;
          color: rgba(255,255,255,0.8);
          font-size: 0.9rem; line-height: 1.6;
        }
        .contact-icon {
          width: 32px; height: 32px; border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0; margin-top: 1px;
        }

        @media (max-width: 768px) {
          .footer-grid { grid-template-columns: 1fr !important; }
          .footer-cols { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>

            <footer style={{
                background: isDark
                    ? 'linear-gradient(160deg, #080312 0%, #11051c 45%, #1a082b 80%, #230838 100%)'
                    : 'linear-gradient(135deg, #4c1360 0%, #6d278b 45%, #C1348B 88%, #cc3f98 100%)',
                color: '#fff',
                fontFamily: "'DM Sans', sans-serif",
                position: 'relative',
                overflow: 'hidden',
                transition: 'background 0.4s ease',
            }}>
                {/* Decoración superior */}
                <div style={{
                    position: 'absolute', top: 0, left: 0, right: 0, height: '4px',
                    background: `linear-gradient(90deg, #61257B, #C1348B, #c1348b, #EA8406, #FFD97C)`,
                    boxShadow: isDark ? '0 0 16px rgba(193, 52, 139, 0.6)' : 'none',
                }} />

                {/* Malla hexagonal animada de izquierda a derecha con degradé suave en el footer */}
                <HexagonCornerDecoration
                    variant="horizontal-degrade"
                    direction="left-to-right"
                    opacity={isDark ? 0.75 : 0.55}
                    style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        pointerEvents: 'none',
                        zIndex: 1,
                    }}
                />

                {/* Blob decorativo suave */}
                <div style={{
                    position: 'absolute', top: '-100px', right: '-100px',
                    width: '420px', height: '420px',
                    background: `radial-gradient(circle, rgba(193,52,139,0.18) 0%, transparent 70%)`,
                    pointerEvents: 'none',
                }} />
                <div style={{
                    position: 'absolute', bottom: '-80px', left: '-80px',
                    width: '360px', height: '360px',
                    background: `radial-gradient(circle, rgba(97,37,123,0.22) 0%, transparent 70%)`,
                    pointerEvents: 'none',
                }} />

                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '64px 32px 0', position: 'relative', zIndex: 2 }}>

                    {/* Main grid */}
                    <div className="footer-grid" style={{
                        display: 'grid',
                        gridTemplateColumns: '1.6fr 1fr 1fr 1.4fr',
                        gap: '48px',
                        marginBottom: '56px',
                    }}>

                        {/* ═══ Col 1: Logo + descripción + newsletter ═══ */}
                        <div>
                            {/* Logo text en base al manual */}
                            <div style={{ marginBottom: '20px' }}>
                                <span style={{
                                    fontSize: '1.45rem', fontWeight: '900',
                                    color: '#fff', letterSpacing: '0.08em',
                                    textTransform: 'uppercase',
                                    fontFamily: "'DM Sans', sans-serif",
                                }}>
                                    CO MARCA <span style={{ color: '#FFD97C', fontWeight: '800' }}>GROUP</span>
                                </span>
                                <div style={{
                                    width: '38px', height: '3px',
                                    background: `linear-gradient(90deg, #C1348B, #FFD97C)`,
                                    borderRadius: '2px', marginTop: '8px',
                                }} />
                            </div>

                            <p style={{
                                color: 'rgba(255,255,255,0.75)',
                                fontSize: '0.9rem', lineHeight: '1.8',
                                marginBottom: '28px',
                                textAlign: 'justify',
                            }}>
                                Espacios diseñados para impulsar tu crecimiento profesional. Conecta con una comunidad de emprendedores en el corazón de La Paz, Bolivia.
                            </p>

                            {/* Newsletter */}
                            <div style={{ marginBottom: '8px' }}>
                                <p style={{ fontSize: '0.8rem', fontWeight: '600', color: 'rgba(255,255,255,0.5)', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                                    Suscríbete al newsletter
                                </p>
                                <div style={{ display: 'flex' }}>
                                    <input
                                        type="email"
                                        placeholder="tu@email.com"
                                        className="subscribe-input"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        onKeyDown={e => e.key === 'Enter' && handleSubscribe()}
                                    />
                                    <button className="subscribe-btn" onClick={handleSubscribe}>
                                        {sent ? '✓' : 'Enviar'}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* ═══ Col 2: Páginas ═══ */}
                        <div>
                            <h6 style={{ fontSize: '0.8rem', fontWeight: '700', color: 'rgba(255,255,255,0.4)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '20px' }}>
                                Páginas
                            </h6>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                {[
                                    { href: '/', label: 'Inicio' },
                                    { href: '/nosotros', label: 'Nosotros' },
                                    { href: '/servicios', label: 'Servicios' },
                                    { href: '/contacto', label: 'Contáctanos' },
                                    { href: '/blog', label: 'Blog' },
                                ].map((item) => (
                                    <li key={item.href}>
                                        <a href={item.href} className="footer-link">
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* ═══ Col 3: Legal ═══ */}
                        <div>
                            <h6 style={{ fontSize: '0.8rem', fontWeight: '700', color: 'rgba(255,255,255,0.4)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '20px' }}>
                                Legal
                            </h6>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                {[
                                    { href: '/faq', label: 'Preguntas frecuentes' },
                                    { href: '/terminos', label: 'Términos de uso' },
                                    { href: '/privacidad', label: 'Privacidad' },
                                    { href: '/soporte', label: 'Soporte' },
                                ].map((item) => (
                                    <li key={item.href}>
                                        <a href={item.href} className="footer-link">
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* ═══ Col 4: Contacto + redes ═══ */}
                        <div>
                            <h6 style={{ fontSize: '0.8rem', fontWeight: '700', color: 'rgba(255,255,255,0.4)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: '20px' }}>
                                Contacto
                            </h6>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '28px' }}>
                                {[
                                    { Icon: MapPin, text: 'Calle 23 de Calacoto, La Paz, Bolivia', color: '#c1348b' },
                                    { Icon: Mail, text: 'comarca@gmail.com', color: '#C1348B' },
                                    { Icon: Phone, text: '+591 762 04601', color: '#61257b' },
                                ].map(({ Icon, text, color }, i) => (
                                    <div key={i} className="contact-item">
                                        <div className="contact-icon" style={{ background: `${color}25`, border: `1.5px solid ${color}55` }}>
                                            <Icon size={16} color={color} />
                                        </div>
                                        <span style={{ color: 'rgba(255,255,255,0.85)' }}>{text}</span>
                                    </div>
                                ))}
                            </div>

                            {/* Redes sociales */}
                            <div style={{ marginTop: '16px' }}>
                                <p style={{ fontSize: '0.78rem', fontWeight: '600', color: 'rgba(255,255,255,0.45)', marginBottom: '18px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                                    Síguenos
                                </p>
                                <div>
                                    <SocialIcons
                                        align="left"
                                        variant="glass"
                                        buttonSize={42}
                                        iconSize={20}
                                        gap={10}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* ═══ Bottom bar ═══ */}
                    <div style={{
                        borderTop: '1px solid rgba(255,255,255,0.1)',
                        padding: '20px 0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '12px',
                    }}>
                        <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.83rem', letterSpacing: '0.04em' }}>
                            © {new Date().getFullYear()} <strong style={{ color: '#FFD97C' }}>CO MARCA GROUP</strong>. Todos los derechos reservados.
                        </p>
                        <div style={{ display: 'flex', gap: '20px' }}>
                            {['Términos', 'Privacidad', 'Soporte'].map((item) => (
                                <a key={item} href={`/${item.toLowerCase()}`}
                                    style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.82rem', textDecoration: 'none', transition: 'color 0.2s' }}
                                    onMouseEnter={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.7)')}
                                    onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.3)')}
                                >
                                    {item}
                                </a>
                            ))}
                        </div>
                    </div>

                </div>
            </footer>
        </>
    );
};

export default Footer;
